import API from '@/api/api.js'
import Moment from 'moment';

export default class ProductAPIList {
   constructor() {
    let api = new API();
    this.api = api;
  }

  // KOL Related API
   getFullProductList(param, success, error) {
    this.api.get('/product', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  selectProduct(param, success, error) {
    this.api.post('/product/select', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  } 
  deleteProduct(param, success, error) {
    this.api.post('/product/delete', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  deletePackages(param, success, error) {
    this.api.post('/product/delete', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  uploadImage(param, success, error) {
    this.api.post('/user/uploadFile', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  uploadReceipt(param, success, error) {
    this.api.post('/order/uploadReceipt', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  pay(param, success, error) {
    this.api.post('/order/pay', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/Product/apiList.js